// https://github.com/moment/moment/issues/3650
export default function interopDefault(m) {
  return m["default"] || m;
}


//////////////////
// WEBPACK FOOTER
// /Users/qixian.cs/Documents/GitHub/ant-design-pro-site/scaffold/node_modules/_antd@3.12.2@antd/es/_util/interopDefault.js
// module id = 83
// module chunks = 0